<template>
<v-container>
  <v-row>
    <Preview
      class="mt-4"
      title="Playtest Discord"
      destination="https://discord.gg/ZvNsmRUjBj"
      :graphic="require('@/assets/discord.jpg')"
    />
    <v-spacer />
    <Preview
      class="mt-4"
      title="Rulebook"
      :destination="rulebook"
      :graphic="require('@/assets/website title.png')"
    />
    <v-spacer />
    <Preview
      class="mt-4"
      title="Blank Character Sheet"
      :destination="blankSheet"
      :graphic="require('@/assets/website char sheet.png')"
    />
    <v-spacer />
    <Preview
      class="mt-4"
      title="Example Character Sheet"
      :destination="filledSheet"
      :graphic="require('@/assets/website char sheet.png')"
    />
  </v-row>
  <v-card class="mt-8">
    <v-card-title class="text-h5"> Tranquility Changelog </v-card-title>
    <v-divider />
    <v-card-text>
      <v-card
        v-for="update in changelog"
        :key="update.version"
        color="#e2e2e2"
        :class="update === firstUpdate ? '' : 'mt-8'"
      >
        <v-card-title>
          {{ update.version }}
        </v-card-title>
        <v-card-text>
          <v-list dense color="#e2e2e2">
            <v-list-item
              v-for="change in update.changes"
              :key="change"
            >
              <v-list-item-icon>
                <v-icon>
                  mdi-circle-medium
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content> {{ change }} </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</v-container>
  

</template>

<script>
import Changelog from './Changelog'
import Preview from './Preview'
export default {
  name: 'Development',

  components: {
    Preview
  },

  computed: {
    firstUpdate () {
      return this.changelog[0]
    },
    rulebook () {
      const vNum = this.firstUpdate.version
      return `/PMD Tranquility ${vNum}.pdf`
    },
    blankSheet () {
      const vNum = this.firstUpdate.version
      return `/Tranquility Character Sheet ${vNum}.pdf`
    },
    filledSheet () {
      const vNum = this.firstUpdate.version
      return `/Tranquility Example Character Sheet ${vNum}.pdf`
    }
  },

  data: () => ({
    changelog: Changelog
  }),
};
</script>
